export default "__VITE_ASSET__DEieYIKX__"